import { render, staticRenderFns } from "./CategoryParent.vue?vue&type=template&id=7bc5cb0e&scoped=true&"
import script from "./CategoryParent.vue?vue&type=script&lang=js&"
export * from "./CategoryParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc5cb0e",
  null
  
)

export default component.exports